// Mock data for Trustpilot clone - Alecc company reviews

export const companyData = {
  name: "Alecc",
  domain: "aleccstore.fr",
  trustScore: 4.6,
  totalReviews: 916,
  category: "Maison & jardin",
  categorySlug: "home_garden",
  profileClaimed: true,
  address: "rue Paul Verlaine, 12850, Onet le Chateau, France",
  phone: "0788463353",
  email: "contact@aleccstore.fr",
  website: "https://aleccstore.fr",
  responseRate: 100,
  responseTime: "2 semaines",
  ratingDistribution: {
    5: 78,
    4: 12,
    3: 5,
    2: 3,
    1: 2
  }
};

export const reviews = [
  {
    id: 1,
    author: "Jean-Pierre M.",
    rating: 5,
    date: "28 janv. 2026",
    experienceDate: "14 janvier 2026",
    title: "Pas encore installée",
    content: "Pas encore installée",
    verified: true,
    hasCompanyResponse: true,
    companyResponse: {
      date: "29 janv. 2026",
      content: "Bonjour, Merci beaucoup pour votre retour. Nous comprenons tout à fait que le produit n'ait pas encore été installé à ce stade. N'hésitez pas à prendre le temps nécessaire pour l'installation et la mise en service. Nous espérons qu'une fois installé, il vous apportera entière satisfaction. Merci encore pour votre avis et votre confiance. Cordialement, L'équipe Alecc"
    }
  },
  {
    id: 2,
    author: "Marie L.",
    rating: 5,
    date: "22 janv. 2026",
    experienceDate: "12 janvier 2026",
    title: "très bien rapide et la prestation…",
    content: "très bien rapide et la prestation convient à mes attentes. Une information entre la commande et la livraison serait bien venue.",
    verified: true,
    hasCompanyResponse: true,
    companyResponse: {
      date: "22 janv. 2026",
      content: "Bonjour, Merci beaucoup pour votre retour positif ! Nous sommes ravis d'apprendre que la rapidité et la prestation ont été à la hauteur de vos attentes. Nous prenons aussi bonne note de votre remarque : nous allons renforcer la communication entre la commande et la livraison. Cordialement, L'équipe Alecc"
    }
  },
  {
    id: 3,
    author: "Philippe D.",
    rating: 4,
    date: "5 janv. 2026",
    experienceDate: "8 décembre 2025",
    title: "je n'ai mis que quatre étoiles",
    content: "je n'ai mis que quatre étoiles car pour le moment je n'ai pas encore déplié la toile. en principe tout a l'air correct. la livraison et le colis était parfait",
    verified: true,
    hasCompanyResponse: true,
    companyResponse: {
      date: "7 janv. 2026",
      content: "Bonjour, Un grand merci pour votre retour positif ! Votre satisfaction est notre plus belle récompense. Cordialement, L'équipe Alecc"
    }
  },
  {
    id: 4,
    author: "Sophie R.",
    rating: 5,
    date: "20 déc. 2025",
    experienceDate: "22 novembre 2025",
    title: "Expédition rapide",
    content: "Expédition rapide, produit conforme",
    verified: true,
    hasCompanyResponse: true,
    companyResponse: {
      date: "22 déc. 2025",
      content: "Bonjour, Un grand merci pour votre retour positif ! Votre satisfaction est notre plus belle récompense. Cordialement, L'équipe Alecc"
    }
  },
  {
    id: 5,
    author: "Laurent B.",
    rating: 5,
    date: "8 déc. 2025",
    experienceDate: "3 novembre 2025",
    title: "Bâche D'hiver",
    content: "Le service à la clientèle m'a donné d'excellentes mises à jour de la livraison et la couverture de la piscine a été livrée comme prévu et le chauffeur est très utile pour transporter la couverture à la destination de la piscine.",
    verified: true,
    hasCompanyResponse: true,
    companyResponse: {
      date: "8 déc. 2025",
      content: "Bonjour, Un grand merci pour votre retour positif ! Votre satisfaction est notre plus belle récompense. Cordialement, L'équipe Alecc"
    }
  },
  {
    id: 6,
    author: "Catherine V.",
    rating: 5,
    date: "7 déc. 2025",
    experienceDate: "2 novembre 2025",
    title: "je recommande !",
    content: "le site est bien conçu et permet d'entrer les mesures exactes du store que l'on souhaite. Les délais de livraison sont très correcte et la qualité du tissu parfaite. C'était ma première commande et je suis entièrement satisfaite. Je recommande",
    verified: true,
    hasCompanyResponse: true,
    companyResponse: {
      date: "7 déc. 2025",
      content: "Bonjour, Un grand merci pour votre retour positif ! Votre satisfaction est notre plus belle récompense. Cordialement, L'équipe Alecc"
    }
  },
  {
    id: 7,
    author: "Michel T.",
    rating: 5,
    date: "30 oct. 2025",
    experienceDate: "2 octobre 2025",
    title: "Rapidité et efficacité",
    content: "Rapidité et efficacité",
    verified: true,
    hasCompanyResponse: true,
    companyResponse: {
      date: "30 oct. 2025",
      content: "Bonjour, Un grand merci pour votre retour positif ! Votre satisfaction est notre plus belle récompense. Cordialement, L'équipe Alecc"
    }
  },
  {
    id: 8,
    author: "Isabelle F.",
    rating: 5,
    date: "14 oct. 2025",
    experienceDate: "6 septembre 2025",
    title: "Réactifs, efficaces",
    content: "J'ai commandé un store enroulable. J'ai dû faire appel au service client en envoyant un mail et on m'a répondu dès le lendemain. On m'a donné très clairement toutes les infos que je demandais.",
    verified: true,
    hasCompanyResponse: true,
    companyResponse: {
      date: "14 oct. 2025",
      content: "Bonjour, Un grand merci pour votre retour positif ! Votre satisfaction est notre plus belle récompense. Cordialement, L'équipe Alecc"
    }
  },
  {
    id: 9,
    author: "François G.",
    rating: 1,
    date: "8 sept. 2025",
    experienceDate: "25 août 2025",
    title: "Plus aucune réponse depuis 10 jours...",
    content: "Nous avons commandé une toile pergola, un plan nous a été adressé mais non conforme car nous n'avons aucun rail mais seulement une traverse horizontale, de ce fait nous avons envoyé plusieurs emails, appelés presque tous les jours et contacter par chat, mais aucune réponse, messagerie direct et pleine. Cela n'est pas très professionnel...",
    verified: false,
    redirected: true,
    hasCompanyResponse: true,
    companyResponse: {
      date: "17 sept. 2025",
      content: "Bonjour, Nous sommes sincèrement désolés pour cette mauvaise expérience. Vous n'avez effectivement pas eu de chance : nous avions pu vous transmettre le plan pour validation juste avant notre fermeture. Nous comprenons parfaitement votre déception. Cordialement, L'équipe Alecc"
    }
  },
  {
    id: 10,
    author: "Anne-Marie P.",
    rating: 5,
    date: "9 sept. 2025",
    experienceDate: "12 août 2025",
    title: "Après avoir été conseillé par Alecc sur…",
    content: "Après avoir été conseillé par Alecc sur les dimensions nous avons reçu plusieurs échantillons de toile pour le store. Il a été livré dans les délais et la qualité est top.",
    verified: true,
    hasCompanyResponse: true,
    companyResponse: {
      date: "17 sept. 2025",
      content: "Bonjour, Un grand merci pour votre retour positif ! Votre satisfaction est notre plus belle récompense. Cordialement, L'équipe Alecc"
    }
  }
];

export const aiSummary = {
  title: "Résumé des avis",
  subtitle: "Basé sur les avis de l'entreprise, créé avec l'IA",
  content: "Les auteurs d'avis ont, dans l'ensemble, vécu une expérience formidable avec cette entreprise. Les consommateurs sont particulièrement satisfaits de la qualité des produits, soulignant qu'ils répondent parfaitement à leurs attentes. De plus, la rapidité de la fabrication et de la livraison est un point fort souvent mentionné, permettant aux clients de profiter rapidement de leurs achats. Les consommateurs apprécient également la facilité d'utilisation du site web pour passer commande. Les échanges avec le personnel sont perçus comme positifs, les clients relevant le professionnalisme, la réactivité et l'amabilité des équipes."
};

export const relatedCompanies = [
  {
    id: 1,
    name: "Point Bâches & Stores",
    domain: "www.pointbaches12.com",
    trustScore: 4.8,
    totalReviews: "4 k"
  },
  {
    id: 2,
    name: "Lumixia",
    domain: "lumixia.fr",
    trustScore: 3.8,
    totalReviews: "28"
  },
  {
    id: 3,
    name: "Helm WMS",
    domain: "helmwms.com",
    trustScore: 4.5,
    totalReviews: "42"
  },
  {
    id: 4,
    name: "Maison 1921",
    domain: "maison-1921.com",
    trustScore: 4.4,
    totalReviews: "43"
  },
  {
    id: 5,
    name: "Geoplanete",
    domain: "geoplanete.fr",
    trustScore: 4.8,
    totalReviews: "167"
  },
  {
    id: 6,
    name: "Zolena",
    domain: "zolena.fr",
    trustScore: 2.6,
    totalReviews: "4"
  }
];

export const popularMentions = [
  "Qualité",
  "Commande",
  "Service de livraison",
  "Produit",
  "Recommandation",
  "Communication client",
  "Service",
  "Service client"
];

export const filterOptions = [
  { value: "recent", label: "Les plus récents" },
  { value: "highest", label: "Note la plus élevée" },
  { value: "lowest", label: "Note la plus basse" }
];
